
import * as CryptoJS from 'crypto-js';

const defaultIv = CryptoJS.enc.Utf8.parse("\0".repeat(16));

export class NonceUtility {

    public static hash(secret: string): string {
        return CryptoJS.SHA1(secret).toString();
    }

    public static encrypt(secret: string, password: string): string {

        const encryption = CryptoJS.DES
            .encrypt(
                secret,
                /// Have to pass password as an WordArray otherwise it will be treated with a key derivation function
                CryptoJS.enc.Utf8.parse(password),
                {
                    iv: defaultIv,
                })
            .toString();

        return encryption;
    }

    public static decrypt(secret: string, password: string): string {

        return CryptoJS.DES
            .decrypt(
                secret,
                CryptoJS.enc.Utf8.parse(password),
                {
                    iv: defaultIv,
                })
            .toString(CryptoJS.enc.Utf8);
    }

    /**
     * 
     * @param nonce  This should be taken from the environment configuration - const nonce = ConfigService?.environment?.nonce;
     * @returns The request nonce or null
     */
    public static tryGenerate(tenant: string, hostname: string, nonce: string): string {

        let key = null;

        if (nonce?.length) {
            try {
                const [, , extractedKey] = nonce.split('.');
                key = extractedKey;
            } catch (error) {

            }
        } else {
            // Not sure why this is hardcoded
            key = NonceUtility.hash('portal')
        }

        if (key) {
            const nonce = NonceUtility.encrypt(`${tenant}:${hostname}:${Date.now() + 15_000}`, key);
            return nonce;
        }

        return null;

    }

    public static tryDecrypt(secret: string, password: string): string {
        try {
            return NonceUtility.decrypt(secret, password);
        } catch (error) {
            return null;
        }
    }

}